import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {OrdersWithPayment} from '../_models/order';

@Injectable()
export class CurrentOrderService {

  private source = new BehaviorSubject<OrdersWithPayment>(null);
  current = this.source.asObservable();
  /** The order the POS holds right now, synchronously (null before one is loaded). */
  get snapshot(): OrdersWithPayment | null { return this.source.value; }

  constructor() {}

  changeCurrentOrder(orderWithPayment:OrdersWithPayment, key:string){
    this.source.next(orderWithPayment);
  }

  clearCurrentOrder(key: string) {
    this.source.next(null);
  }

}
